import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    useTheme,
    Typography,
    Divider,
    Menu,
    MenuItem,
    AppBar,
    Toolbar,
    Container,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    Popover,
    useMediaQuery,
} from '@mui/material';
import {
    Menu as MenuIcon,
    Dashboard as DashboardIcon,
    Assessment as AssessmentIcon,
    Settings as SettingsIcon,
    ChevronLeft as ChevronLeftIcon,
} from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { tokens } from '../../../../theme';

import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Helmet } from 'react-helmet';

import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import { useProject } from '../../../../context/ProjectContext';
import config from '../../../../config';
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const Sidebar013 = ({ isPlanningOpen, setIsPlanningOpen, isSettingsOpen, setIsSettingsOpen }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const { handleLogout } = useProject();
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const projecturl = "esid-25-013";
    const projectname = "Leadgen";
    const menuItems = [
        {
            title: 'Dashboard',
            icon: <DashboardIcon fontSize="medium" />,
            path: `/${projecturl}/dashboard`,
        },
        {
            title: 'Settings',
            icon: <SettingsIcon fontSize="medium" />,
            path: `/${projecturl}/settings`,
        },
    ];

    const clickItem = (item) => {
        if (item.title === 'Settings') {
            setIsSettingsOpen(!isSettingsOpen);
        } else {
            navigate(item.path);
        }
    }
    const drawerWidth = 240;
    const logout = async () => {
        await handleLogout();
        localStorage.removeItem('selectedProject');
        localStorage.removeItem('allowedPages');
        localStorage.removeItem('allowedProjects');
        localStorage.removeItem('all_roles');
        if(projecturl==='esid-25-013'){
            navigate('/signin-leadgen');
        }else{
            navigate('/signin');
        }
    }
    const handleOpenSettings = () => setOpenSettings(true);

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const getPageTitle = () => {
        switch (config.meta.STAGE) {
            case 'prod':
                return `Energy Optimizer - ${projectname}`;
            case 'uat':
                return `Energy Optimizer - ${projectname} [UAT]`;
            default:
                return `Energy Optimizer - ${projectname} [DEV ${config.meta.VERSION}]`;
        }
    };



    return (
        <Box >
            <AppBar position="static" enableColorOnDark sx={{
                boxShadow: 0,
                //bgcolor: "#e0e0e0",
                bgcolor: "rgba(72,63,94,0.1)",
                //bgcolor: "rgba(63,124,128,0.2)",
                //bgcolor:colors.entras_purple[100],
                backgroundImage: 'none',
                width: "100%", borderRadius: 2,
                height: 45,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                alignContent: "center",
                alignSelf: "center"
            }}>
                <Container maxWidth="100%">
                    <Toolbar disableGutters>
                        {/* Mobile menu button */}
                        <Box sx={{ display: { xs: 'inline-flex', sm: 'none' }, ml: 1, mr: 1 }}>
                            <IconButton onClick={() => setMobileOpen(true)} aria-label="open menu">
                                <MenuIcon fontSize="inherit" sx={{ color: colors.grey[100] }} />
                            </IconButton>
                        </Box>
                        {/* Brand logo (hidden on mobile to save space) */}
                        <Box component="a" href="/" sx={{ textDecoration: 'none', display: { xs: 'none', sm: 'inline-flex' } }}>
                            <img
                                src="/assets/Endustries-positief.svg"
                                alt="Logo"
                                height={15}
                                style={{ cursor: 'pointer', marginTop: 4, marginLeft: 40 }}
                            />

                        </Box>
                        <Helmet>
                            <title>{getPageTitle()}</title>
                        </Helmet>
                        <div className={`testapp ${config.meta.VERSION} ${config.meta.STAGE}`}>TEST</div>
                        {isInfoOpen && (
                            <Popover
                                open={isInfoOpen}
                                anchorEl={document.querySelector('button[aria-label="info"]')} // Reference to info button
                                onClose={() => setIsInfoOpen(false)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <Box
                                    sx={{
                                        p: 2,
                                        bgcolor: 'background.paper',
                                        borderRadius: 1,
                                        boxShadow: 1,
                                        minWidth: 200,
                                    }}
                                >
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        Application Info
                                    </Typography>
                                    {/* add user info */}
                                    <Typography variant="body2">
                                        User: {localStorage.getItem('useremail')}
                                    </Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="body2">
                                        Version: {config.meta.VERSION}
                                    </Typography>
                                    <Typography variant="body2">
                                        Stage: {config.meta.STAGE}
                                    </Typography>
                                    {config.meta.RELEASE_DATE && (
                                        <Typography variant="body2">
                                            Release Date: {config.meta.RELEASE_DATE}
                                        </Typography>
                                    )}
                                </Box>
                            </Popover>
                        )}


                        <Box sx={{ flexGrow: 1, flexDirection: "row", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>

                            <Box component="a" href="/" sx={{ textDecoration: 'none', display: { xs: 'none', sm: 'inline-flex' } }}>
                                <img
                                    src="/assets/poweredbyentras-paars.png"
                                    alt="Logo"
                                    height={30}
                                    style={{
                                        cursor: 'pointer',
                                        marginRight: 20, marginTop: 4,
                                    }}
                                />

                            </Box>
                        </Box>

                        <Box sx={{ flexGrow: 0, flexDirection: "row", display: "flex" }}>
                            <IconButton
                                onClick={() => setIsInfoOpen(!isInfoOpen)}
                                aria-label="info"  // Add this line
                            >
                                <InfoOutlinedIcon fontSize="inherit"
                                    sx={{ color: colors.grey[100] }} />
                            </IconButton>
                            <Divider sx={{}} orientation="vertical" variant="middle" flexItem />

                            <IconButton
                                href='https://entras.be/helpdesk/'
                                target="_blank" // Opens the link in a new tab
                                rel="noopener noreferrer"
                            >
                                <HelpOutlineOutlinedIcon fontSize="inherit"
                                    sx={{ color: colors.grey[100] }} />
                            </IconButton>

                            <Divider sx={{}} orientation="vertical" variant="middle" flexItem />

                            <IconButton
                                onClick={() => setIsSettingsOpen(!isSettingsOpen)}
                            >
                                <SettingsOutlinedIcon fontSize="inherit" sx={{ color: colors.grey[100] }} />

                            </IconButton>
                            <Divider sx={{}} orientation="vertical" variant="middle" flexItem />
                            
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                        <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            {/* Desktop/sidebar drawer */}
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    width: 45,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: isOpen ? drawerWidth : 45,
                        boxSizing: 'border-box',
                        
                        overflow: "hidden",
                        backgroundColor: colors.entras_purple[100],
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    },
                }}
            >

                <Box sx={{
                    height: "100%", justifyContent: "center",
                    alignItems: "center",
                    display: "flex", alignContent: "center",
                    alignSelf: "center"
                }}>
                    <List>
                        {menuItems.map((item) => (
                            <ListItem
                                button
                                key={item.title}
                                onClick={() => clickItem(item)}
                                sx={{
                                    backgroundColor: location.pathname === item.path ?
                                        colors.blueAccent[800] : 'transparent',
                                    '&:hover': {
                                        backgroundColor: colors.blueAccent[800],
                                    },
                                    borderRadius: "100%",
                                    width: 30,
                                    height: 30,
                                    mt: 4,
                                    mb: 4,
                                    ml: 1,
                                    mr: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",

                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        color: location.pathname === item.path ?
                                            colors.grey[100] : colors.grey[900],
                                        justifyContent: "center",
                                        '&:hover': {
                                            color: colors.grey[100],
                                        },
                                    }}
                                >
                                    {item.icon}
                                </ListItemIcon>

                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>

            {/* Mobile temporary drawer */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={() => setMobileOpen(false)}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: colors.entras_purple[100],
                    },
                }}
            >
                <Box sx={{
                    height: "100%", justifyContent: "center",
                    alignItems: "center",
                    display: "flex", alignContent: "center",
                    alignSelf: "center"
                }}>
                    <List>
                        {menuItems.map((item) => (
                            <ListItem
                                button
                                key={item.title}
                                onClick={() => { clickItem(item); setMobileOpen(false); }}
                                sx={{
                                    backgroundColor: location.pathname === item.path ?
                                        colors.blueAccent[800] : 'transparent',
                                    '&:hover': {
                                        backgroundColor: colors.blueAccent[800],
                                    },
                                    borderRadius: "100%",
                                    width: 40,
                                    height: 40,
                                    mt: 2,
                                    mb: 2,
                                    ml: 1,
                                    mr: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",

                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        color: location.pathname === item.path ?
                                            colors.grey[100] : colors.grey[900],
                                        justifyContent: "center",
                                        '&:hover': {
                                            color: colors.grey[100],
                                        },
                                    }}
                                >
                                    {item.icon}
                                </ListItemIcon>

                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>

        </Box>
    );
};

export default Sidebar013;